
const initTeamSlider = () => {
  const teamSlider = document.querySelector('.team-slider');

  if (!teamSlider) return;

  const previousBtn = document.querySelector('.previous-btn');
  const nextBtn = document.querySelector('.next-btn');

  const previousSliderBtn = document.getElementById('previous-btn-slidenav');
  const nextSliderBtn = document.getElementById('next-btn-slidenav');

  previousBtn.addEventListener('click', () => {
    previousSliderBtn.click();
  });

  nextBtn.addEventListener('click', () => {
    nextSliderBtn.click();
  });
};

export default initTeamSlider;
